import { render, staticRenderFns } from "./WMDS.Result.vue?vue&type=template&id=9fc483b0&"
import script from "./WMDS.Result.vue?vue&type=script&lang=js&"
export * from "./WMDS.Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports